<ion-header class="my-0">
	<div class="content-header">
		<span class="element-header">{{ shoppingCartHeader$ | async }}</span>
		<span (click)="closeCart()">
			<app-icon [iconName]="'close'" />
		</span>
	</div>
</ion-header>

<ng-template #cartItem>
	<div class="element-cart-item">
		<ng-container *ngIf="cartItems$ | async as cartItems">
			<app-cart-items
				[cartItems$]="cartItems$"
				[showSummary]="showSummary"
				[currentStep]="currentStep"
				(itemDeleted)="onItemDeleted($event)"
				(itemChanged)="changeAmount($event)"
			/>
		</ng-container>
	</div>

	<div class="content-summary">
		<app-summary [showSummary]="showSummary" [isCart]="true"></app-summary>
	</div>
</ng-template>

<div class="content-body">
	<ng-container *ngIf="cartItemEmpty$ | async; else cartView">
		<div class="cart-item-empty-container">
			<app-icon iconName="cart" />
			<span class="title">You don't have any products in your cart yet.</span>
			<app-button text="Start shopping" type="button-primary" (buttonClicked)="closeCart()" />
		</div>
	</ng-container>
	<ng-template #cartView>
		<ng-container *ngTemplateOutlet="cartItem"></ng-container>
	</ng-template>
</div>
